import styled from "styled-components";

export const Stage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 2rem 0;
  margin: 0 -5%;
  overflow: hidden;
`;
export const DotFlash = styled.div`
  position: relative;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  background-color: ${({ theme }) => {
    return theme.colors.green;
  }};
  color: ${({ theme }) => {
    return theme.colors.green;
  }};
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;

  &::before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
  }
  &::after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
  }

  &::before {
    left: -40px;
    width: 21px;
    height: 21px;
    border-radius: 50%;
    background-color: ${({ theme }) => {
      return theme.colors.green;
    }};
    color: ${({ theme }) => {
      return theme.colors.green;
    }};
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 0s;
  }

  &::after {
    left: 40px;
    width: 21px;
    height: 21px;
    border-radius: 50%;
    background-color: ${({ theme }) => {
      return theme.colors.green;
    }};
    color: ${({ theme }) => {
      return theme.colors.green;
    }};
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 1s;
  }

  @keyframes dotFlashing {
    0% {
      background-color: ${({ theme }) => {
        return theme.colors.green;
      }};
    }
    50%,
    100% {
      background-color: #a8b3ae;
    }
  }
`;
